export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11856.536e93f4.jpg";